export const getFilersSelector = (state, name) => state?.filters?.[name];
